/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Cta_ButtonInputs */

const en_fw_cta_button = /** @type {(inputs: Fw_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the episode schedule`)
};

const zh_fw_cta_button = /** @type {(inputs: Fw_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看播出时间表`)
};

/**
* | output |
* | --- |
* | "See the episode schedule" |
*
* @param {Fw_Cta_ButtonInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_cta_button = /** @type {((inputs?: Fw_Cta_ButtonInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Cta_ButtonInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_cta_button(inputs)
	return zh_fw_cta_button(inputs)
});
export { fw_cta_button as "fw.cta.button" }